var cloneSvg = function cloneSvg(sourceSvg) {
  return sourceSvg.cloneNode(true);
};
export default cloneSvg;